<template>
  <div>
    <h4 v-if="deliveryType === 'email' || countryNotEnabled">
      Entrez le code à 6 chiffres que vous avez reçu dans votre boîte mail à l'adresse {{ hiddenContact }}.
    </h4>
    <h4 v-else>
      Pour vous identifier, veuillez entrer le code à 6 chiffres reçu par SMS au {{ formattedPhone }}
    </h4>
    <Alert title="Ce code restera valide pendant 15 minutes" type="info" />
    <Otp
      ref="otp"
      inputRef="otpInput"
      @onComplete="$emit('complete', $event)"
      :isError="errorOtp"
      :errorMsg="errorOtpMsg"
      :showCountdown="isCountdown && !isBlocked"
      :showSendAgain="!isCountdown && !isBlocked"
      :isDisabled="isLoading"
      @onSendAgain="$emit('resend')"
      @onCountDownEnd="$emit('countdownEnded')"
      linkText="Renvoyer un nouveau code"
    />
    <div v-if="isLoading" class="d-flex align-items-center mt-2">
      <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
      <span>Vérification en cours...</span>
    </div>
    <button
      v-else
      @click="$emit('validate')"
      :disabled="isBlocked || otp.length < 6"
      class="btn btn-info mt-1 mr-1 mb-1 mb-md-0"
      type="button"
    >
      Continuer
    </button>
  </div>
</template>

<script>
import Alert from '@/components/Alert/Alert'
import Otp from '@/components/Otp/Otp'

export default {
  name: 'StepOtp',
  components: { Alert, Otp },
  props: {
    otp: { type: String, required: true },
    hiddenContact: { type: String, required: true },
    deliveryType: { type: String, required: true },
    countryNotEnabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isBlocked: { type: Boolean, default: false },
    isCountdown: { type: Boolean, default: false },
    errorOtp: { type: Boolean, default: false },
    errorOtpMsg: { type: String, default: '' },
  },
  emits: ['complete', 'validate', 'resend', 'countdownEnded'],
  computed: {
    formattedPhone () {
      const s = this.hiddenContact
      return `${s.slice(0, 3)} ${s.slice(3, 4)} ${s.slice(4, 6)} ${s.slice(6, 8)} ${s.slice(8, 10)} ${s.slice(10, 12)}`
    },
  },
}
</script>
